var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 1H1V17H17V1ZM1 0H0V1V17V18H1H17H18V17V1V0H17H1ZM5.625 4.5L7.875 2.25H2.25V7.875L4.5 5.625L6.75 7.875L7.875 6.75L5.625 4.5ZM15.75 15.75H10.125L12.375 13.5L10.125 11.25L11.25 10.125L13.5 12.375L15.75 10.125V15.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenWhite);
export default __webpack_public_path__ + "static/media/screen-white.49ba8e476cc67858104609e33eab94d0.svg";
export { ForwardRef as ReactComponent };